<mat-dialog-content>
  <div *ngIf="showDefault">
    <mat-toolbar class="text-uppercase">
      <mat-toolbar-row>
        <span>Cutoff Padrão - {{ cutoffName }}</span>
        <span class="spacer"></span>
        <button class="closeModal" [mat-dialog-close]="true">
          <i class="fa fa-sm fa-times"></i>
        </button>
      </mat-toolbar-row>
    </mat-toolbar>

    <mat-card *ngIf="showActions()">
      <mat-card-header></mat-card-header>
      <mat-card-content class="container-fluid">
        <div class="row mb-2">
          <div class="col-6">
            <label>Gestora</label>
            <ng-select
              [clearSearchOnAdd]="true"
              [items]="accountManagerListToFilter"
              bindLabel="name"
              bindValue="id"
              [(ngModel)]="selectedAccountManager"
              [ngModelOptions]="{ standalone: true }"
              (change)="filterResultByAccountManager()"
            >
              <ng-option
                *ngFor="let item of accountManagerListToFilter"
                [value]="item"
                >{{ item.document }} {{ item.name }}</ng-option
              >
            </ng-select>
          </div>
          <div class="col-6">
            <label>Fundo</label>
            <ng-select
              [clearSearchOnAdd]="true"
              [items]="fundListToFilter"
              bindLabel="name"
              bindValue="id"
              [(ngModel)]="selectedFund"
              [ngModelOptions]="{ standalone: true }"
              notFoundText="Não há cutoff padrão para fundos"
              (change)="filterResultByFund()"
            >
              <ng-option *ngFor="let item of fundListToFilter" [value]="item"
                >{{ item.document }} {{ item.name }}</ng-option
              >
            </ng-select>
          </div>
        </div>
      </mat-card-content>
    </mat-card>

    <table mat-table [dataSource]="cutoffFilteredList" class="hours">
      <ng-container matColumnDef="actions" *ngIf="canChangeCutoffDefault()">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let item" class="actions">
          <i
            class="fa fa-lg fa-list-alt"
            (click)="openTimeUpdate(item.ticketCutoffDefaultId)"
            title="Alterar horário default"
          ></i>
        </td>
      </ng-container>

      <ng-container matColumnDef="accountManagerName" *ngIf="showActions()">
        <th mat-header-cell *matHeaderCellDef>Gestora</th>
        <td
          mat-cell
          *matCellDef="let item"
          [class.out-of-vigor]="!item.isActive"
        >
          {{ item.accountManagerName }}
        </td>
      </ng-container>

      <ng-container matColumnDef="fundName">
        <th mat-header-cell *matHeaderCellDef>Fundo</th>
        <td mat-cell *matCellDef="let item">{{ item.fundName }}</td>
      </ng-container>

      <ng-container matColumnDef="defaultLimitTime">
        <th mat-header-cell *matHeaderCellDef>Horário Limite Padrão</th>
        <td
          mat-cell
          *matCellDef="let item"
          [class.out-of-vigor]="!item.isActive"
        >
          <span [class.out-of-vigor]="item.currentLimitTime">
            {{ item.defaultLimitTime | date: "HH:mm":"-0300" }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="currentLimitTime">
        <th mat-header-cell *matHeaderCellDef>Horário Limite Vigente</th>
        <td
          mat-cell
          *matCellDef="let item"
          [class.out-of-vigor]="!item.isActive"
        >
          {{ item.currentLimitTime | date: "HH:mm":"-0300" }}
          <i
            class="fas fa-info-circle info-warning"
            title="Horário válido somente para o dia vigente."
            *ngIf="item.currentLimitTime"
          ></i>
        </td>
      </ng-container>

      <ng-container
        matColumnDef="request"
        *ngIf="canChangeLimitTime && !isIndex"
      >
        <th mat-header-cell *matHeaderCellDef>
          Solicitar extensão horário limite
        </th>
        <td mat-cell *matCellDef="let item">
          <button
            mat-raised-button
            color="primary"
            (click)="
              openCreateCutoff(
                cutoffOperationTypeEnum.Exception,
                item.ticketCutoffTypeId,
                item.accountManagerId,
                item.fundId
              )
            "
            [disabled]="!item.isActive"
          >
            Solicitar
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>

  <div *ngIf="showException">
    <mat-toolbar class="text-uppercase">
      <mat-toolbar-row>
        <span>Exceções</span>
        <span class="spacer"></span>
        <button
          class="closeModal"
          [mat-dialog-close]="true"
          *ngIf="!showDefault"
        >
          <fa-icon [icon]="faTimes"></fa-icon>
        </button>
      </mat-toolbar-row>
    </mat-toolbar>
    <table
      mat-table
      [dataSource]="cutoffExceptionList"
      class="hours"
      *ngIf="cutoffExceptionList"
    >
      <ng-container matColumnDef="accountManagerName" *ngIf="showActions()">
        <th mat-header-cell *matHeaderCellDef>Gestora</th>
        <td
          mat-cell
          *matCellDef="let item"
          [class.out-of-vigor]="!item.isActive"
        >
          {{ item.accountManagerName }}
        </td>
      </ng-container>

      <ng-container matColumnDef="fundName">
        <th mat-header-cell *matHeaderCellDef>Fundo</th>
        <td
          mat-cell
          *matCellDef="let item"
          [class.out-of-vigor]="!item.isActive"
        >
          {{ item.fundName }}
        </td>
      </ng-container>

      <ng-container matColumnDef="defaultLimitTime">
        <th mat-header-cell *matHeaderCellDef>Horário Limite Padrão</th>
        <td
          mat-cell
          *matCellDef="let item"
          [class.out-of-vigor]="!item.isActive"
        >
          <span [class.out-of-vigor]="item.currentLimitTime">
            {{ item.defaultLimitTime | date: "HH:mm":"-0300" }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="currentLimitTime">
        <th mat-header-cell *matHeaderCellDef>Horário Limite Vigente</th>
        <td
          mat-cell
          *matCellDef="let item"
          [class.out-of-vigor]="!item.isActive"
        >
          {{ item.currentLimitTime | date: "HH:mm":"-0300" }}
          <fa-icon
            [icon]="faInfoCircle"
            title="Abertura de horário válida no dia apenas para o fundo selecionado, demais fundos permanecem com o horário padrão."
            *ngIf="item.currentLimitTime && item.fundId"
          ></fa-icon>
          <fa-icon
            [icon]="faInfoCircle"
            title="Horário válido todos os fundos, somente para o dia vigente."
            *ngIf="item.currentLimitTime && !item.fundId"
          ></fa-icon>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
</mat-dialog-content>
